import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from } from '@guardian/source/foundations';
const tabletSvg = css `
	position: absolute;
	top: 0;
	min-height: 100%;
	display: none;

	${from.mobileLandscape} {
		display: inline;
	}

	${from.desktop} {
		display: none;
	}
`;
export default function SvgSquaresHeroTablet() {
    return (_jsx("svg", { className: "svg-squares-hero-tablet", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 768 382", preserveAspectRatio: "xMinYMid slice", css: tabletSvg, children: _jsxs("g", { fill: "none", fillRule: "evenodd", children: [_jsx("path", { d: "M-72 305h87v87h-87z", fill: "#5CC9F8" }), _jsx("path", { d: "M-19 285h87v87h-87z", fill: "#2EBDFB" }), _jsx("path", { d: "M34 262h87v87H34z", fill: "#00B2FF" }), _jsx("path", { d: "M444 352h87v87h-87z", fill: "#E8E0CF" }), _jsx("path", { d: "M414 322h87v87h-87z", fill: "#E8D8BF" }), _jsx("path", { d: "M394 302h87v87h-87z", fill: "#E9D2AF" }), _jsx("path", { d: "M374 282h87v87h-87z", fill: "#EACCA0" }), _jsx("path", { d: "M520 15h87v-87h-87z", fill: "#D86AA9" }), _jsx("path", { d: "M460 55h87v-87h-87z", fill: "#D33F92" }), _jsx("path", { d: "M410 85h87V-2h-87z", fill: "#CE147C" }), _jsx("path", { d: "M701 173h87V86h-87z", fill: "#F0ADA5" }), _jsx("path", { d: "M636 194h87v-87h-87z", fill: "#F58D7F" }), _jsx("path", { d: "M568 214h87v-87h-87z", fill: "#FA6D5A" }), _jsx("path", { d: "M501 238h87v-87h-87z", fill: "#FF4E36" })] }) }));
}
